/* eslint-disable tailwindcss/no-custom-classname */

import { FC, memo } from "react";
import { Checkbox } from "@/components/atoms/inputForms/Checkbox";
import OpenNewTabIcon from "/public/icon/open_new_tab.svg";
import Link from "next/link";
import { IsDefault, IsMobile } from "@/components/atoms/mediaQuery/MediaQuery";

interface Props {
  serviceId: number | string;
  setIsAgree: (value: boolean) => void;
  isAgree: boolean;
  isShowTerm?: boolean;
  setIsOpenPrivacypolicyModal?: () => void;
}

const TermPolicyBase: FC<Props> = ({
  setIsAgree,
  serviceId,
  isAgree = false,
  isShowTerm,
  setIsOpenPrivacypolicyModal
}) => {
  return (
    <div className="flex gap-1 flex-wrap md:flex-nowrap items-center justify-center  w-full md:w-auto text-center">
      <Checkbox
        id="check_agreement"
        onChange={(e: { target: { checked: boolean } }) => {
          setIsAgree(e.target.checked);
        }}
        value="check_agreement"
        checked={isAgree}
      />
      <div className="text-center tracking-tight text-base font-bold flex text-[#1A1A1C]">
        {isShowTerm && (
          <>
            <Link
              href={`/terms/service/${serviceId}`}
              target="_blank"
              className="text-[#47BDAB] flex items-center gap-1">
              利用規約 <OpenNewTabIcon />

            </Link>
            ・
          </>
        )}
        <IsDefault>
          <Link
            href={`/privacy?id=${serviceId}`}
            target="_blank"
            className="text-[#47BDAB] flex items-center gap-1">
            プライバシーポリシー <OpenNewTabIcon />

          </Link>
        </IsDefault>
        <IsMobile>
          <span
            className="link text-[#47BDAB] inline-flex items-center gap-1 cursor-pointer"
            onClick={setIsOpenPrivacypolicyModal}
          >
            プライバシーポリシー
          </span>
        </IsMobile>
      </div>
      <span className="ml-1 text-[#1A1A1A] text-base font-bold text-center !block w-full md:w-auto md:inline-block">
        に同意する
      </span>
    </div>
  );
};

export const TermPolicy = memo(TermPolicyBase);
